import React from 'react';
import { getFPUExplanation } from '../utils/fpuCalculations';
import './DisclaimerModal.css'; // Reuse disclaimer modal styles

interface FPUExplanationModalProps {
  isOpen: boolean;
  onClose: () => void;
  language: 'en' | 'de';
}

export const FPUExplanationModal: React.FC<FPUExplanationModalProps> = ({
  isOpen,
  onClose,
  language
}) => {
  if (!isOpen) return null;

  const isGerman = language === 'de';
  
  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="disclaimer-backdrop" onClick={handleBackdropClick}>
      <div className="disclaimer-modal">
        <div className="disclaimer-header">
          <h2 className="disclaimer-title">{isGerman ? 'FPE Information' : 'FPU Information'}</h2>
          <button className="disclaimer-close" onClick={onClose}>×</button>
        </div>
        <div className="disclaimer-content">
          {getFPUExplanation(language).split('\n').map((line, index) => (
            <p key={index} className="disclaimer-paragraph">{line}</p>
          ))}
        </div>
        <div className="disclaimer-footer">
          <button className="disclaimer-button" onClick={onClose}>
            {isGerman ? 'Verstanden' : 'Got it'}
          </button>
        </div>
      </div>
    </div>
  );
};